import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { App } from "./App";
import { PRERENDERED_PATHS } from "./lib/routes";
import { installGlobalErrorLogging } from "./lib/logger";
import "./theme.css";
import "./styles.css";

// Anything no flow caught still leaves a row behind.
installGlobalErrorLogging();

const container = document.getElementById("root")!;
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Public pages ship as pre-rendered HTML, so adopt it rather than throwing it away.
// Everything else (the signed-in app) is served from a bare shell and renders fresh.
if (PRERENDERED_PATHS.has(window.location.pathname) && container.firstChild) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
